import { Inject, Injectable } from '@angular/core';

import { IUiState } from 'packages/sports/web/app/src/ui-manager/ui-manager.state';
import { hasUiState } from 'packages/sports/web/app/src/ui-manager/ui-state-helper';
import { UiStates } from 'packages/sports/web/app/src/ui-manager/ui-states.enum';

import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../../base/services/betslip-messages-provider.service';
import { BetslipError } from '../../validation/errors/betslip-error';
import { ExtendedBetslipNotification, IBetslipNotification, SimpleBetslipNotification } from '../../validation/errors/betslip-notification';
import { OddsChangedPreCheckError } from '../../validation/errors/pre-check/odds-changed-pre-check-error';
import { BetslipNotificationMessageType, IBetslipNotificationState } from '../state';

@Injectable()
export class BetslipNotificationUtils {
    private readonly messages: {
        globalToastMessage: string;
        editBet: {
            cashOutFailedTitle: string;
            cashOutFailedMessage: string;
            toastMessage: string;
        };
    };

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) private messageProvider: IBetslipMessagesProviderService) {
        const messages = this.messageProvider.getMessages();
        this.messages = {
            globalToastMessage: messages.common.GlobalToastMessage,
            editBet: {
                cashOutFailedTitle: messages.editBet.cashOutFailedTitle,
                cashOutFailedMessage: messages.editBet.cashOutFailedMessage,
                toastMessage: messages.editBet.toastMessage,
            },
        };
    }

    getToastNotification(errors: BetslipError[], uiState: IUiState): IBetslipNotification {
        const isInEditBet = hasUiState(uiState, UiStates.EditBet);

        return isInEditBet ? this.getEditBetToastMessage(errors) : new SimpleBetslipNotification(this.messages.globalToastMessage);
    }

    getEditBetToastMessage(errors: BetslipError[]): IBetslipNotification {
        if (errors.find((error) => error instanceof OddsChangedPreCheckError)) {
            return new ExtendedBetslipNotification(this.messages.editBet.cashOutFailedTitle, this.messages.editBet.cashOutFailedMessage);
        }

        return new SimpleBetslipNotification(this.messages.editBet.toastMessage);
    }

    isBetBuilderNotification(notification: IBetslipNotificationState): boolean {
        return (
            notification.messageType === BetslipNotificationMessageType.BetBuilder ||
            notification.messageType === BetslipNotificationMessageType.NotSet
        );
    }
}
